import React, {ReactNode, useEffect, useState} from "react"
import {Box, Button, Card, Chip, Divider, Grid, IconButton, Input, LinearProgress, Stack, Typography} from "@mui/joy";
import {
    Search,
    Type,
    Wind
} from "lucide-react";
import {useAsync} from "../hooks/useAsyncResult";
import LoadingPageComponent from "../components/Loading/LoadingPageComponent";
import {getTestResults} from "../services/api/session";
import TestResultItemComponent from "../components/Test/TestResultItemComponent";
import EmptyResultsComponent from "../components/Test/NoResultsComponent";
import PaginationComponent from "../components/PaginationComponent";
import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import LoadingError from "../components/Error/LoadingError";

const ResultsPage = () => {
    const [searchParams] = useSearchParams()
    const testResultsAsyncResult = useAsync(getTestResults, true)
    const {t} = useTranslation()

    const loadResults=()=>{
        testResultsAsyncResult.execute(parseInt(searchParams.get("page")))
    }

    useEffect(() => {
        loadResults()
    }, [searchParams])

    return <Stack gap={1} padding={2} sx={{height: "100dvh"}}>

        <Stack gap={1}>
            <Typography level={"h2"}>
                {t("resultTitle")}
            </Typography>
            <Typography>
                {t("resultDescription")}
            </Typography>
        </Stack>

        {!testResultsAsyncResult.isSuccess && !testResultsAsyncResult.loading && <LoadingError label={t("resultTitle")} onRetry={loadResults} />}

        {testResultsAsyncResult?.loading ?
            <LoadingPageComponent label={t("resultTitle")}/> :
            testResultsAsyncResult.isSuccess &&
            <Stack gap={2}>

                <Stack gap={2} paddingY={2}>
                    <Grid container spacing={2}>
                        {testResultsAsyncResult.payload.data?.length > 0 ? testResultsAsyncResult.payload.data?.map(session =>
                                <Grid xs={12} lg={6}>
                                    <TestResultItemComponent session={session} testTitle={session.testTitle}/>
                                </Grid>) :
                            <EmptyResultsComponent/>}
                    </Grid>

                    <PaginationComponent pageCount={Math.ceil((testResultsAsyncResult.payload?.count || 0) / 15)}/>

                </Stack>

            </Stack>}


    </Stack>
}

export default ResultsPage